(function($){

    var Banners = {

        $items : null,

        init : function(){

            this.$items = $( '.banner-personagens' );
            if( !this.$items.length ) return true;

            this.$items.each(function(){
                Banners.configureItem( this );
            });

        },

        configureItem : async function( banner ){

            banner.$ = banner.$ || $( banner );
            var type = banner.$.data( 'type' );

            const datas = await Banners.requestItem( type );
            if( !datas.length ){

                banner.$.remove();
            
            }
            else {

                data = datas.shift();

                // Título
                $( '[data-meta="titulo"]', banner.$ ).html( data.title.rendered );
                
                // Descrição
                $( '[data-meta="descricao"]', banner.$ ).html( data.excerpt.rendered );

                // Chapeu
                const $chapeu = $( '[data-meta="chapeu"]', banner.$ );
                if( $chapeu.length && data.chapeu ){
                    $chapeu.html( data.chapeu );
                }
                
                // Image
                const $image = $( data.image ).attr( 'loading', 'lazy' );
                $( '.image-wrapper', banner.$ ).html('').append( $image );

                // Link
                var $link = $( 'a[data-meta="link-banner"]', banner.$ );
                if( $link.length ){
                    if( data.link_url ){
                        $link.html( data.link_label ).attr( 'href', data.link_url );
                    }
                    else {
                        $link.remove();
                    }   
                }

                banner.$.fadeIn();
                
            }
            
        },

        requestItem : async function( type ){            
            return new Promise(function( resolve, reject ){
                $.ajax({
                    //url: 'https://cliente.pikiweb.com/wp-json/wp/v2/banner?type=' + type,
                    url: 'https://personagenssebrae.com.br/wp-json/wp/v2/banner?type=' + type,
                    type: 'GET',
                    dataType: 'JSON',
                    success: function( data ){
                        resolve( data );
                    },
                    error: function( err ){
                        reject( err );
                    }
                });
            });

        }

    };

    $(function(){ 
        Banners.init(); 
    });

})(jQuery);
